export const errores = {
    101: 'User not found',
    102: 'Internal server error'
};
